export const HOURLY_DAY_KEYS = [
  "MON",
  "TUE",
  "WED",
  "THU",
  "FRI",
  "SAT",
  "SUN",
  "WEEKDAY_AVERAGE",
  "WEEKEND_AVERAGE"
];

export const HOURLY_DAY_LABELS = {
  MON: "Monday",
  TUE: "Tuesday",
  WED: "Wednesday",
  THU: "Thursday",
  FRI: "Friday",
  SAT: "Saturday",
  SUN: "Sunday",
  WEEKDAY_AVERAGE: "Weekday avg",
  WEEKEND_AVERAGE: "Weekend avg"
};

export { HOURLY_DAY_COLORS } from "./colorPalette";

export const DEFAULT_ENABLED_HOURLY_DAYS = ["WEEKDAY_AVERAGE", "WEEKEND_AVERAGE"];
